// periods
import React, { useMemo, useRef } from 'react';
import { gql, useFragment, useReactiveVar } from '@apollo/client';

import { regionSubdivisionVar } from 'app/apollo/reaction';

const D_PERIODS_FRAGMENT = gql`
fragment ALL_FILTER_PERIODS_FRAGMENT on menuSidebar {
    periods {
        start
        end
        isVisibleInFilter
        categories {
            id
            title
            description
        }
        tags {
            id
            title
            categoryId: category_id
            categoryName: category_name
            erp_id
        }
    }
    subdivision
}`;

/**
 * @description useFragment читает данные с returnPartialData: true,
 * поэтому вместо null может вернуть объект без поля periods
 * (например сразу после смены региона, когда данные нового региона еще не пришли).
 * Такие данные отдавать наружу нельзя - все консьюмеры ждут массив periods
 */
const isPeriodsDataActual = (menuSidebarData, subdivision) => (
    Array.isArray(menuSidebarData?.periods)
    && menuSidebarData?.subdivision === subdivision?.replace(/_/g, '-')
);

const EMPTY_PERIODS_DATA = {
    periods: [],
    categories: [],
    tags: [],
};

/**
 * @description читает данные данные периудов, меню фильтров и из apollo cache
 */
export const useMenuPeriodsData = (currentSubdivision) => {
    const subdivisionVar = useReactiveVar(regionSubdivisionVar);
    const subdivision = currentSubdivision || subdivisionVar;

    const { data } = useFragment({
        fragment: D_PERIODS_FRAGMENT,
        from: {
            __ref: `menuSidebar:{"subdivision":"${subdivision?.replace(/_/g, '-')}"}`,
        },
    });

    const lastValidDataRef = useRef(
        isPeriodsDataActual(data, subdivision) ? data : EMPTY_PERIODS_DATA,
    );

    return useMemo(() => {
        if (isPeriodsDataActual(data, subdivision)) {
            lastValidDataRef.current = data;
            return data;
        }

        return lastValidDataRef.current;
    }, [data, subdivision]);
};
